import { COLORS } from '@btime/constants'
import React from 'react'

import { TableCol, TableHead, TableRow } from './Table'
import Text from './Text'
import { usePdfOptionsForm } from './options/_form/PdfOptionsFormHandler'

export const TableColLabelValue = ({ label, value, children, semibold, ...props }) => {
  return (
    <TableCol {...props}>
      <Text bold={semibold ? false : true} semibold={semibold} inline>
        {label}:
      </Text>{' '}
      {children ? children : <Text inline>{value}</Text>}
    </TableCol>
  )
}

export const TableRowLabelValue = ({
  label,
  colSpan,
  value,
  children,
  borderColor = COLORS.dark4,
  textAlign = 'left',
  colTextAlign = 'unset',
  useFontBaseColor,
  semibold,
  ...props
}) => {
  const { fontBaseColor } = usePdfOptionsForm()

  const selectedColor = useFontBaseColor ? fontBaseColor : borderColor || COLORS.dark4
  return (
    <TableRow color={selectedColor}>
      <TableCol color={selectedColor} colSpan={colSpan} style={{ verticalAlign: colTextAlign }}>
        <Text bold={semibold ? false : true} semibold={semibold} style={{ textAlign }}>
          {label}:
        </Text>
      </TableCol>
      <TableCol color={selectedColor}>{children ? children : <Text inline>{value}</Text>}</TableCol>
    </TableRow>
  )
}

export const TableColText = ({
  colSpan,
  rowSpan,
  bgColor,
  width,
  height,
  children,
  color,
  style,
  useFontBaseColor,
  ...props
}) => {
  return (
    <TableCol
      colSpan={colSpan}
      rowSpan={rowSpan}
      width={width}
      height={height}
      bgColor={bgColor}
      color={color}
      style={style}
      useFontBaseColor={useFontBaseColor}
    >
      <Text {...props}>{children}</Text>
    </TableCol>
  )
}

export const TableHeadText = ({ colSpan, rowSpan, bgColor, width, children, useFontBaseColor, semibold, ...props }) => {
  return (
    <TableHead colSpan={colSpan} rowSpan={rowSpan} width={width} bgColor={bgColor} useFontBaseColor={useFontBaseColor}>
      <Text bold={semibold ? false : true} semibold size="small" {...props}>
        {children}
      </Text>
    </TableHead>
  )
}
